import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { DialogState, OnCloseKey } from './types';

const initialState: DialogState = {
  dialogMessage: null,
  dialogTitle: '',
  isDialogOpen: false,
  onCloseKey: null,
};

export const DialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    closeDialog: (state) => {
      state.isDialogOpen = false;
      state.dialogMessage = null;
      state.dialogTitle = '';
      state.onCloseKey = null;
    },

    openDialog: (state) => {
      state.isDialogOpen = true;
    },

    setDialogMessage: (state, action: PayloadAction<string | React.ReactNode>) => {
      state.dialogMessage = action.payload;
    },

    setDialogTitle: (state, action: PayloadAction<string>) => {
      state.dialogTitle = action.payload;
    },

    setOnCloseKey: (state, action: PayloadAction<OnCloseKey>) => {
      state.onCloseKey = action.payload;
    },
  },
});

export const { closeDialog, openDialog, setDialogMessage, setDialogTitle, setOnCloseKey } = DialogSlice.actions;

export default DialogSlice.reducer;
